export default {
  props:{
    formGroupClass: String,
    hasFeedback: Boolean,
    inline: Boolean,
    inputWrapperClass: String,
    label: String,
    labelClass: String,
    labelRight: Boolean,
    labelInvisible: Boolean,

    validateVid: String,
    validateRules: [Object, String],
    validateDisabled: Boolean,
    validateCustomMessages: Object
  },
}